import { useTranslation } from "react-i18next";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { useForm } from "antd/lib/form/Form";
import { FunctionComponent } from "react";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { get } from "lodash";
import "./filter-group.scss";
import { staticReportStore } from "../../../../../stores/stores";

type FormFilterProps = {
  showFilter?: boolean;
  clearFilter: (form: FormInstance) => void;
  onFinish?: any;
  dataOptions?: any;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  onFinish,
  showFilter,
  clearFilter,
  dataOptions,
}) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const { tab } = staticReportStore();
  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form name="filterForm" onFinish={onFinish} form={form}>
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            {tab !== "1" ? (
              <Col
                xl={{ span: 5 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Giảng viên", "Giảng viên")}</Typography.Title>
                <Form.Item name="lecturer">
                  <FormItemDropdown
                    modeDropdown="multiple"
                    disabled={tab === "1"}
                    allowClear
                    placeholder={t("Chọn giảng viên", "Chọn giảng viên")}
                    options={get(dataOptions, "dataLecturer", "")}
                  />
                </Form.Item>
              </Col>
            ) : null}

            {tab !== "1" ? (
              <Col
                xl={{ span: tab === "1" ? 6 : 5 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Cấp", "Cấp")}</Typography.Title>
                <Form.Item name="level">
                  <FormItemDropdown
                    modeDropdown="multiple"
                    disabled={tab === "1"}
                    allowClear
                    placeholder={t("Chọn cấp", "Chọn cấp")}
                    options={get(dataOptions, "dataLevel", "")}
                  />
                </Form.Item>
              </Col>
            ) : null}

            <Col
              xl={{ span: tab === "1" ? 6 : 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Khối", "Khối")}</Typography.Title>
              <Form.Item name="unit">
                <FormItemDropdown
                  modeDropdown="multiple"
                  allowClear
                  placeholder={t("Chọn khối", "Chọn khối")}
                  options={get(dataOptions, "dataUnit", "")}
                />
              </Form.Item>
            </Col>

            {tab !== "1" ? (
              <Col
                xl={{ span: tab === "1" ? 6 : 5 }}
                md={{ span: 4 }}
                sm={{ span: 4 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Khóa học", "Khóa học")}</Typography.Title>
                <Form.Item name="course">
                  <FormItemDropdown
                    modeDropdown="multiple"
                    disabled={tab === "1"}
                    allowClear
                    placeholder={t("Chọn khóa học", "Chọn khóa học")}
                    options={get(dataOptions, "dataCourse", "")}
                  />
                </Form.Item>
              </Col>
            ) : null}

            <Col
              xl={{ span: 3 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                >
                  <FilterOutlined />
                  <Typography.Text> {t("Lọc", "Lọc")} </Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={() => clearFilter(form)}
                >
                  <DeleteOutlined />
                  <Typography.Text> {t("Xóa bộ lọc", "Xóa bộ lọc")} </Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
